import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledPersonalDataForm = styled(StyledFlex)`
   padding-bottom: 12px;
`;
